//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueDPlayer from '@/libs/dplayer'
export default {
    name: 'VideoPlayer',
    components: {
		    'd-player': VueDPlayer
		},
    props: {
        url: {
            type: String,
            default: ''
        },
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            innerSrc:''
        }
    },
    computed:{
        src(){
            if(this.innerSrc != ''){
                return this.innerSrc
            }
            return this.url
        },
        doptions() {
            let result = {
                video: {
                    url: '',
                    pic: ''
                },
                autoplay: true
            }
            result.video.pic = this.src+'?vframe/jpg/offset/1'
            result.video.url = this.src
            return result
        },
    },
    methods: {
        play(url){
            this.innerSrc = url
        },
        close() {
            this.innerSrc = ''
            this.$emit('input', false)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/VideoPlayer.vue